import{__exports as e}from"../../../_virtual/dispatchTrackingEvent.js";var t;t=e,Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e){"undefined"!=typeof window&&Object.keys(e).length>0&&(window.dataLayer=window.dataLayer||[]).push(e)};
//# sourceMappingURL=dispatchTrackingEvent.js.map
